const openCard = (card) => {
    card.classList.add('-open');
    card.classList.remove('-closed');
};

const closeCard = (card) => {
    card.classList.add('-closed');
    card.classList.remove('-open');
};

const delegateCardClicks = (ev, card) => {
    if (ev.target.tagName === 'A') {
        const href = ev.target.getAttribute('href');

        if (href.startsWith('#') === false) {
            return;
        }
        ev.preventDefault();
        if (href === '#open') {
            openCard(card);
        } else {
            closeCard(card);
        }
    }
};

export default function peoplePageInit(peopleCards = []) {
    peopleCards.forEach((card) => {
        card.addEventListener('click', (event) => {
            delegateCardClicks(event, card);
        });
    });
}
